/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Rule } from './Rule.js';
import {
    RuleFromJSON,
    RuleFromJSONTyped,
    RuleToJSON,
} from './Rule.js';

/**
 * 
 * @export
 * @interface RuleSingleResponse
 */
export interface RuleSingleResponse {
    /**
     * 
     * @type {Rule}
     * @memberof RuleSingleResponse
     */
    data?: Rule;
    /**
     * 
     * @type {number}
     * @memberof RuleSingleResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleSingleResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleSingleResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof RuleSingleResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the RuleSingleResponse interface.
 */
export function instanceOfRuleSingleResponse(value: object): boolean {
    return true;
}

export function RuleSingleResponseFromJSON(json: any): RuleSingleResponse {
    return RuleSingleResponseFromJSONTyped(json, false);
}

export function RuleSingleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleSingleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : RuleFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function RuleSingleResponseToJSON(value?: RuleSingleResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': RuleToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

